module.exports = __webpack_public_path__ + "media/assets/logo21-e6c034a7.jpg";